import { QueryClient } from '@tanstack/react-query'
import { ApiError } from '../api/problem'

/**
 * Retrying a 4xx cannot help: a 403 will not become permitted, and a 404 under
 * this API's rules means "gone or never yours" (see api/problem.ts). Retrying
 * them only delays the empty state the user should already be looking at.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          if (error instanceof ApiError && error.isClientError) return false
          return failureCount < 2
        },
      },
      mutations: {
        // Mutations are not idempotent here; a retry could double-apply a change.
        retry: false,
      },
    },
  })
}
